export var JobQuestion;
(function (JobQuestion) {
    let node_type;
    (function (node_type) {
        node_type["JOB_RESPONSE"] = "jobResponse";
    })(node_type = JobQuestion.node_type || (JobQuestion.node_type = {}));
})(JobQuestion || (JobQuestion = {}));
